/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Expert_SectionInputs */

const fr_settings_expert_section = /** @type {(inputs: Settings_Expert_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expert`)
};

const en_settings_expert_section = /** @type {(inputs: Settings_Expert_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expert`)
};

/**
* | output |
* | --- |
* | "Expert" |
*
* @param {Settings_Expert_SectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_expert_section = /** @type {((inputs?: Settings_Expert_SectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Expert_SectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_expert_section(inputs)
	return en_settings_expert_section(inputs)
});